module.exports = __webpack_public_path__ + "img/xuexin.af25ec1f.jpg";